
import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { doc, onSnapshot } from "firebase/firestore";

export default function Pricing() {
  const [tiers, setTiers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    const ref = doc(db, "pricing", "default");
    const unsub = onSnapshot(
      ref,
      (snap) => {
        if (snap.exists()) {
          const data = snap.data();
          setTiers(Array.isArray(data.tiers) ? data.tiers : []);
        } else {
          setTiers([]);
        }
        setLoading(false);
      },
      (e) => {
        console.error(e);
        setErr("Could not load pricing.");
        setLoading(false);
      }
    );
    return () => unsub();
  }, []);

  return (
    <div className="bg-[#0a1220] text-center py-20 min-h-screen">
      <h1 className="text-5xl md:text-6xl font-extrabold text-white mb-6">
        Choose Your Wash
      </h1>
      <div className="flex justify-center mb-6">
        <div className="h-2 w-32 rounded-full bg-cyan-400" />
      </div>

      {/* Touch-Free Automatic Car Wash Section */}
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-4xl font-extrabold text-white">
          Touch-Free Automatic Car Wash
        </h2>

        {loading && <p className="mt-6 text-gray-400">Loading prices…</p>}
        {err && <p className="mt-6 text-red-500">{err}</p>}

        {!loading && !err && (
          <div className="mt-10 grid gap-6 md:grid-cols-3">
            {tiers.map((t) => (
              <TierCard key={t.id} tier={t} />
            ))}
          </div>
        )}

        {/* New Self-Serve Bays Section */}
        <div className="mt-20 text-left bg-white/5 rounded-3xl p-8 ring-1 ring-white/10 shadow-xl">
          <h2 className="text-3xl font-extrabold text-white mb-4">
            Self-Serve Bays
          </h2>
          <p className="text-white/90 text-lg mb-4">
            $3.00 for 4 minutes and 20 seconds, $1.00 for each additional 1 minute 20 seconds
          </p>

          <h3 className="text-2xl font-semibold text-cyan-400 mb-3">
            Self-Serve Wash Options
          </h3>
          <ul className="space-y-2 text-white/90">
            {[
              "Pre-Soak",
              "Eco Wash Soap",
              "Foam Brush",
              "Rinse",
              "Wax",
              "Engine Cleaner",
              "Tire Cleaner",
            
            ].map((item, i) => (
              <li key={i} className="flex gap-3 items-start">
                <span className="mt-2 h-2.5 w-2.5 rounded-full bg-cyan-400 shrink-0" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

function TierCard({ tier }) {
  return (
    <div className="rounded-2xl bg-white ring-1 ring-black/10 p-6 flex flex-col text-left">
      <h3 className="font-bold text-xl text-[#0a1220]">{tier.name}</h3>
      <div className="mt-2 text-5xl font-extrabold text-[#0a1220]">
        ${Number(tier.price || 0)}
      </div>

      <ul className="mt-4 space-y-2 text-sm text-[#0a1220]">
        {(tier.features || []).map((f, i) => (
          <li key={i} className="flex gap-2">
            <span className="mt-1.5 h-2 w-2 rounded-full bg-cyan-400 shrink-0" />
            <span>{f}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
